// import { loginWithPhoneNumberProps } from "auth-type";
import authService from "src/services/authService";
import {
	// loginWithPhoneNumberProps,
	regisWithPhoneNumberProps,
} from "auth-types";
import { meType } from "src/types/me-types";
import { broker } from "src/reducers/types/accountTypes";
import { brokerType } from "src/types/broker-types";

export const LOGIN_REQUEST = "@account/login-request";
export const LOGIN_SUCCESS = "@account/login-success";
export const LOGIN_FAILURE = "@account/login-failure";
export const SILENT_LOGIN = "@account/silent-login";
export const LOGOUT = "@account/logout";
export const REGISTER = "@account/register";
export const SET_QUERY_ME = "@account/set-query-me";
export const SET_CURRENT_BROKER = "@account/set-current-broker";
export const SET_BROKER = "@account/set-broker";

export function loginWithPhoneNumber(phoneNo: string, password: string) {
	return async (dispatch: any) => {
		try {
			dispatch({ type: LOGIN_REQUEST });
		} catch (error) {
			dispatch({ type: LOGIN_FAILURE });
			throw error;
		}
	};
}

// export const login = () =>{
//   return async (dispatch:any) => {
//     try {
//       await authService.login();
//     }
//     catch (error) {
//       dispatch(({ type: LOGIN_FAILURE }));
//       throw error;
//     }
//   }
// }

export function regisWithPhoneNumber(
	regisByPhoneNumberGQL: any,
	regisProps: regisWithPhoneNumberProps
) {
	return async (dispatch: any) => {
		try {
			dispatch({ type: LOGIN_REQUEST });

			const { user } = await authService.registerWithPhoneNumber(
				regisByPhoneNumberGQL,
				regisProps
			);
			dispatch({
				type: LOGIN_SUCCESS,
				payload: {
					user,
				},
			});
		} catch (error) {
			dispatch({ type: LOGIN_FAILURE });
			throw error;
		}
	};
}

export function setUserData(me: meType) {
	return (dispatch: (e: any) => void) =>
		dispatch({
			type: SILENT_LOGIN,
			payload: me,
		});
}

export function logout() {
	return async (dispatch: (e: any) => void) => {
		await authService.logout();

		dispatch({
			type: LOGOUT,
		});
	};
}

export function setQueryMe(queryMe: () => void) {
	return async (dispatch: any) => {
		dispatch({
			type: SET_QUERY_ME,
			payload: {
				queryMe: queryMe,
			},
		});
	};
}

export function setCurrentBroker(broker: broker) {
	return async (dispatch: any) => {
		dispatch({
			type: SET_CURRENT_BROKER,
			payload: {
				broker,
			},
		});
	};

}

export function setBroker(broker: brokerType) {
	return async (dispatch: any) => {
		dispatch({
			type: SET_BROKER,
			payload: {
				broker,
			},
		});
	};
}